import React from "react";
import "./css/loader.css";

const Loader: React.FC = () => {
  return <div className="loader"></div>;
};

export default Loader;
